import { FONT_SIZE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";
import { FONT_SIZE_SEARCH_AREA, HEIGHT_SEARCH_AREA } from "./types";

type TextScale = keyof typeof FONT_SIZE;

export const Styles = styled.div<{
  $isSidebarCollapsed: boolean;
  text_scale?: TextScale;
  height?: number;
  $maintenanceBannerHeight?: number;
  isChangeSize?: boolean;
  $isTableList?: boolean;
  $isDisplayInNewTab?: boolean;
}>`
  position: fixed;
  z-index: 80;
  top: ${({ $isTableList, $maintenanceBannerHeight }) =>
    $isTableList ? 48 : 48 + ($maintenanceBannerHeight || 0)}px;
  bottom: 0;
  left: ${({ $isTableList, $isSidebarCollapsed, $isDisplayInNewTab }) =>
    $isTableList
      ? "0"
      : $isDisplayInNewTab
      ? "-10px"
      : $isSidebarCollapsed
      ? "68px"
      : "308px"};

  .wrapper-search_area_box {
    height: 100%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
    overflow-y: hidden;
    overflow-x: visible;
    z-index: 8;
    background-color: #ffffff;
    padding-left: 10px;
    padding-right: 0px;
    /* padding-bottom: 76px; */
    position: relative;
    overflow: visible;
    display: flex;
    flex-direction: column;

    &.box-expend {
      width: 262px;
    }
    &.box-collapse {
      width: 86px;
      width: 30px;
    }

    &.disabled-click {
      opacity: 0.5;
    }

    .search-filter-box {
      height: 50%;
    }

    .ant-divider-horizontal {
      margin: 0;
      width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      margin-bottom: 0 !important;
      border-color: #d9dde5;
    }
  }

  .collapse-box {
    position: absolute;
    right: -20px;
    top: 0px !important;
  }
  .ant-btn-default:not(.none-set) {
    ${({ isChangeSize, height, text_scale }) =>
      isChangeSize &&
      `
        font-size: ${FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
        width: ${
          text_scale === DISPLAY_SIZES.SMALL
            ? "88px"
            : text_scale === DISPLAY_SIZES.MEDIUM
            ? "95px"
            : "105px"
        };
        min-width: ${
          text_scale === DISPLAY_SIZES.SMALL
            ? "88px"
            : text_scale === DISPLAY_SIZES.MEDIUM
            ? "95px"
            : "105px"
        };
        height:  ${height}px !important;
      `}
  }
  .section-title {
    border: 1px solid #1e3665;
    background-color: transparent;
    color: #1e3665;
    margin: 12px 8px 0px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    // padding: 5px 8px;

    ${({ isChangeSize, text_scale = DISPLAY_SIZES.SMALL }) =>
      isChangeSize &&
      `
              font-size: ${FONT_SIZE_SEARCH_AREA[text_scale]}px;
              line-height: ${HEIGHT_SEARCH_AREA[text_scale]}px;
            `}
  }
`;

export const TopSection = styled.div`
  min-height: 45%;
  max-height: 45%;
  flex-shrink: 0;
  padding: 0 0 12px;
  overflow: hidden;
`;

export const BottomSection = styled.div`
  max-height: 50%;
  flex-shrink: 0;
  padding: 12px 0 16px;
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 4px;
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const IconWrapperBottom = styled(IconWrapper)`
  margin-top: 0;
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(227, 227, 227, 0.3);
`;
